var map = {
	"./applab/skins": 2212,
	"./bounce/skins": 2615,
	"./craft/agent/skins": 2619,
	"./craft/code-connection/skins": 2620,
	"./craft/designer/skins": 2618,
	"./craft/simple/skins": 2617,
	"./flappy/skins": 2621,
	"./jigsaw/skins": 2634,
	"./maze/skins": 1870,
	"./netsim/skins": 2691,
	"./p5lab/skins": 2083,
	"./studio/skins": 2693,
	"./studio/starwars/skins": 2235,
	"./turtle/skins": 2273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4010;